import styled from "styled-components";

export const IconBadge = styled.div`
    display: flex;
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: ${props => props.theme.colors.primary40};
    color: ${props => props.theme.colors.primary};
`;

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    border: ${props => props.embedded ? 'none' : `1px solid ${props.selected ? props.theme.colors.primary : props.theme.colors.gray}`};
    border-radius: 16px;
    box-shadow: ${props => props.embedded ? 'none' : 'var(--cards)'};
    padding: ${props => props.embedded ? '0' : '16px 20px'};
    cursor: ${props => props.embedded ? 'default' : 'pointer'};

    .line {
        display: flex;
        flex-direction: row;
        flex: 1;
        min-width: 0;
        gap: 12px;
        align-items: center;
    }

    .content {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 0;
        gap: 2px;

        p {
            font-size: 1.2rem;
            line-height: 1.8rem;
            font-weight: 500;
            color: ${props => props.theme.colors.neutral800};
        }

        .description {
            font-weight: bold;
            font-size: 1.4rem;
            line-height: 2.1rem;
            color: ${props => props.selected ? props.theme.colors.primary : props.theme.colors.neutral900};
        }

        .deadline {
            font-weight: 600;
            color: ${props => props.embedded ? props.theme.colors.error : (props.selected ? props.theme.colors.primary : props.theme.colors.neutral900)};
        }

        .location-info {
            display: flex;
            flex-direction: column;
            gap: 1px;
        }

        .address {
            color: ${props => props.theme.colors.neutral800};
        }

        .distance {
            display: flex;
            gap: 4px;
            align-items: center;
            color: ${props => props.theme.colors.neutral600};

            svg {
                flex: 0 0 auto;
            }
        }

        .legal-info {
            display: flex;
            flex-direction: column;
            gap: 2px;
            margin-top: 8px;

            p {
                font-size: 1.1rem;
                line-height: 1.6rem;
                font-weight: 400;
                color: ${props => props.theme.colors.neutral600};
            }
        }

        .withdrawal-info {
            margin-top: 6px;
            color: ${props => props.theme.colors.neutral800};
        }
    }

    :hover {
        border: ${props => props.embedded ? 'none' : `1px solid ${props.theme.colors.primary}`};
    }
`;

export const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    h2 {
        font-size: 16px;
        font-weight: 700;
        color: ${props => props.theme.colors.neutral900};
    }

    h3 {
        font-size: 15px;
        font-weight: 700;
        color: ${props => props.theme.colors.neutral900};
    }

    span {
        font-size: 14px;
        font-weight: 400;
        color: ${props => props.theme.colors.neutral900};
    }

    .distance{
            display: flex;
            gap: 2px;
            align-items: center;
    }

    .line{
        display: flex;
        gap: 2px;

        span{
            align-self: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            
        }
    }
`;
